import React from 'react';
import { Modal, Input, Form, Select, Checkbox } from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    elemento: parseInt(values.elemento),
                    codigoCuenta: values.codigoCuenta,
                    descripcion: values.descripcion,
                    idTipoCuenta: values.idTipoCuenta.key,
                    operacionAsociada: values.operacionAsociada,
                    codigoPadre: values.codigoPadre,
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('codigoPadre', { initialValue: this.props.formValues.codigoPadre });

        return (
            <Modal
                title={(this.props.formValues.id === 0 ? "Registrar" : "Modificar") + " Plan de Cuenta"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="700px"
            >
                <Form>

                <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Elemento">
                                {getFieldDecorator('elemento', {
                                    initialValue: this.props.formValues.elemento,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }
                                       
                                    ]
                                })(
                                    <Input
                                        placeholder="Ingresar Elemento"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Código Cuenta">
                                {getFieldDecorator('codigoCuenta', {
                                    initialValue: this.props.formValues.codigoCuenta,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Código Cuenta"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Descipción">
                                {getFieldDecorator('descripcion', {
                                    initialValue: this.props.formValues.descripcion,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Input
                                    placeholder="Ingresar Descipción"
                                    autoComplete="off"
                                />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo Cuenta">
                                {getFieldDecorator('idTipoCuenta', {
                                    initialValue: this.props.formValues.idTipoCuenta > 0 ?
                                        { key: this.props.formValues.idTipoCuenta } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Cambio"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tipoCuenta.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Operación Asociada">
                                {getFieldDecorator('operacionAsociada', {
                                    initialValue: this.props.formValues.operacionAsociada,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Input
                                    placeholder="Ingresar operacion Asociada"
                                    autoComplete="off"
                                />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)